<template>
	<div class="setUp">
		<ul class="qunData">
			<li>
				<h1>群资料</h1>
			</li>
			<li>
				<label>群号码：</label>
				<span>{{getQunData.group_no}}</span>
			</li>
			<li>
				<label>群分类：</label>
				<span>{{getQunData.group_type}}</span>
			</li>
			<li>
				<label>群标签：</label>
				<span>{{getQunData.group_label}}</span>
			</li>
			<li>
				<label>群位置：</label>
				<span>{{getQunData.group_address}}</span>
			</li>
			<li>
				<label>群公告：</label>
				<span>{{getQunData.group_notice}}</span>
			</li>
			<li>
				<h1>群成员</h1>
			</li>
			<li>
				<div class="box" v-if="getMemberData.owner">
					<div class="item" style="margin-right: 50px;">
						<img :src="getMemberData.owner[0].headImg" :title="getMemberData.owner[0].nickName"  />
						<span>群主</span>
					</div>				
					<div class="item" v-for="item in getMemberData.members">
						<img :src="item.headImg" :title="item.nickName"  />
					</div>
					<div style="clear: both;"></div>
				</div>
			</li>
		</ul>
		<div class="btn">
			<el-button  type="primary" size="medium" round @click="chooseMaster()">联系群主</el-button>
		</div>
		<div class="btn" style="padding-top: 50px;">
			<el-button size="medium" round @click="tuiChu()">退群</el-button>
		</div>
	</div>
</template>

<script>
import qs from "qs"	
export default {	
  data () {
    return {
    	qunData:[],
		memberData:[],
		 
    }
  },
  computed:{
  	getQunData:function(){
  		return this.qunData
  	},
  	getMemberData:function(){
  		return this.memberData
  	},
  },
  methods:{
	getInfo(data){
		this.qunData=data.setUpData.qunData
		this.memberData=data.setUpData.memberData
	},
   	tuiChu(){
		this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
		this.$axios.post('/goods/mimc/v1/quitGroup/'+this.getQunData.group_no)
		.then(userData=>{
			console.log(userData)
			if(userData.data.resultCode=="0000"){
				this.$parent.tuiChu(this.getQunData.group_no);
			}else if(userData.data.resultCode=="1313"){
				this.$parent.loginto();
			}else{
				this.$message.error(userData.data.resultMsg);
			} 

		}).catch(error=>{
			console.log(error)
		})   	
   					
  	},
	  chooseMaster(){
	  	var data={
					ms_type:'0',
					msg_to:this.getMemberData.owner[0].conNum,
					ms_title:this.getMemberData.owner[0].nickName,
					user:this.getMemberData.owner[0].account,
					ms_logo:this.getMemberData.owner[0].headImg,
					
				}
	  	this.$parent.chooseMaster(data);
				
	  },  
	setcookie(name, value){ 
	    //设置名称为name,值为value的Cookie
	    var expdate = new Date();   //初始化时间
	    expdate.setTime(expdate.getTime() + 24*7*60 * 60 * 1000);   //时间单位毫秒 过期时间30分钟
	    document.cookie = name+"="+value+";expires="+expdate.toGMTString()+";path=/";
	 
	   //即document.cookie= name+"="+value+";path=/";  时间默认为当前会话可以不要，但路径要填写，因为JS的默认路径是当前页，如果不填，此cookie只在当前页面生效！
	},
	getCookie(c_name){
	//判断document.cookie对象里面是否存有cookie
	if (document.cookie.length>0){
	  var c_start=document.cookie.indexOf(c_name + "=")
		//如果document.cookie对象里面有cookie则查找是否有指定的cookie，如果有则返回指定的cookie值，如果没有则返回空字符串
	  if (c_start!=-1){ 
	    c_start=c_start + c_name.length+1 
	   var c_end=document.cookie.indexOf(";",c_start)
	    if (c_end==-1) c_end=document.cookie.length
	     return unescape(unescape(document.cookie.substring(c_start,c_end)))
	    } 
	  }
	return ""
	},		  
  },
  created:function(){
  	
  		
	
  },
}	
</script>

<style scoped>
.setUp{
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background: #FFFFFF;
	z-index: 100;
	padding: 15px;
	overflow: auto;
}
.qunData{
	
}
.qunData li{}
.qunData label{
	color: #888888;
	font-size: 14px;
}
.qunData span{
	font-size: 14px;
	line-height: 25px;
}
.qunData h1{
	font-size: 16px;
	font-weight: normal;
	padding-bottom: 15px;
	
}
.qunData .box{
	
}
.qunData .item{
	float: left;
	margin: 5px;
	position: relative;
	
}
.qunData .item span{
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	background: #f56c6c;
	color: #FFFFFF;
	text-align: center;
	font-size: 10px;
	display: block;
	border-radius: 10px;
	left: 40px;
}
.qunData img{
	width: 40px;
	height: 40px;
	border-radius: 100%;	
}
.qunData b{}
.btn{
	margin: 20px 0;
}
.btn button{
	width: 100%;
} 
</style>


// WEBPACK FOOTER //
// src/components/im/setUp.vue